module.exports = __webpack_public_path__ + "img/tel-azul.956d00d7.svg";